import React, { FC, ReactNode } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

interface ConfirmPayPalActionDialogProps {
  open: boolean;
  title: string;
  children: ReactNode;
  confirmLabel: string;
  confirmColor?: 'primary' | 'error';
  isSubmitting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation step for every PayPal account change: each one moves where a store's PayPal
 * payments are routed, so none of them may happen on a single click.
 */
export const ConfirmPayPalActionDialog: FC<ConfirmPayPalActionDialogProps> = ({
  open,
  title,
  children,
  confirmLabel,
  confirmColor = 'error',
  isSubmitting,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={isSubmitting ? undefined : onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent dividers>
      <Typography variant="body2">{children}</Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={isSubmitting}>
        Cancel
      </Button>
      <Button variant="contained" color={confirmColor} onClick={onConfirm} disabled={isSubmitting}>
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
